import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const initHeader = () => {
	const header = document.getElementById("header");
	const mobileNav = document.getElementById("mobile-nav");
	const mobileToggle = document.getElementById("mobile-menu-toggle");

	if (header && window.innerWidth >= 1024) {
		let isHidden = false;

		ScrollTrigger.create({
			start: `top -${window.innerHeight}px`,
			end: "max",
			onUpdate: (self) => {
				const shouldHide = self.direction === 1;
				if (shouldHide === isHidden) return;

				isHidden = shouldHide;
				gsap.to(header, {
					y: shouldHide ? -header.offsetHeight - 10 : 0,
					duration: 1.6,
					ease: "power3.out",
				});
			},
		});
	}

	if (mobileNav && mobileToggle) {
		gsap.set(mobileNav, { xPercent: 100 });

		const bars = mobileToggle.querySelectorAll("span");
		const [top, mid, bot] = bars;
		// gap-[6px] between 2px bars = 8px center-to-center
		const offset = 8;

		let isOpen = false;

		const openMenu = () => {
			isOpen = true;
			gsap.to(mobileNav, { xPercent: 0, duration: 0.5, ease: "power3.out" });
			gsap.to(mid,  { autoAlpha: 0, duration: 0.2 });
			gsap.to(top,  { y: offset,  rotation: 45,  duration: 0.4, ease: "power3.out" });
			gsap.to(bot,  { y: -offset, rotation: -45, duration: 0.4, ease: "power3.out" });
			document.body.classList.add("overflow-hidden");
		};

		const closeMenu = () => {
			isOpen = false;
			gsap.to(mobileNav, { xPercent: 100, duration: 0.4, ease: "power3.in" });
			gsap.to(mid,  { autoAlpha: 1, duration: 0.2, delay: 0.1 });
			gsap.to(top,  { y: 0, rotation: 0, duration: 0.4, ease: "power3.out" });
			gsap.to(bot,  { y: 0, rotation: 0, duration: 0.4, ease: "power3.out" });
			document.body.classList.remove("overflow-hidden");
		};

		mobileToggle.addEventListener("click", () => {
			isOpen ? closeMenu() : openMenu();
		});
	}
};

export default initHeader;
